module.exports = __webpack_public_path__ + "img/productHSE_17.d0fc85ed.png";